import { Container } from "@/components/Container/Container";
import { Section } from "@/components/Section/Section";
import { Reveal } from "@/components/Reveal/Reveal";
import { missionVision } from "@/spiel/missionVision";
import styles from "./MissionVision.module.scss";

export const MissionVision = () => (
  <Section id="mission">
    <Container narrow>
      <Reveal>
        <p className={styles.label}>{missionVision.missionLabel}</p>
        <blockquote className={styles.mission}>
          {missionVision.mission}
        </blockquote>
      </Reveal>

      <Reveal delay={0.15}>
        <p className={styles.label}>{missionVision.visionLabel}</p>
        <blockquote className={styles.vision}>
          {missionVision.vision}
        </blockquote>
      </Reveal>
    </Container>
  </Section>
);
